<template>
	<div class="skip-requirements">
		<span class="skip-requirements__label">
			{{ translate("ui.skip_requirements_confirm") }}
		</span>
		<div class="skip-requirements__price">
			<span class="label"> {{ translate("ui.price") }}: </span>
			<AppPrice
				:amount="entity.skipQuestGemsPrice"
				:currency="ResourceType.GEMS"
			/>
		</div>
		<AppTextButton
			:type="StatusTypes.SECONDARY"
			:text="translate('button.skip')"
			:shadow="true"
			:disabled="!entity?.canSkipQuest"
			@click="useSkip"
		/>
	</div>
</template>

<script lang="ts" setup>
import AppPrice from "@/components/AppPrice.vue";
import AppTextButton from "@/components/AppTextButton.vue";
import type SettlementCastleBuildingTileEntity from "@/game/entities/buildings/SettlementCastleBuildingTileEntity";
import { ResourceType } from "@/game/entities/config/resources";
import { StatusTypes } from "@/types/ui";
import { translate } from "@/utils/translate";

const props = defineProps<{
	entity: SettlementCastleBuildingTileEntity;
	onSkip: () => void;
}>();

const emit = defineEmits(["closePopup"]);

const useSkip = (): void => {
	props.onSkip();
	emit("closePopup");
};
</script>

<style lang="scss" scoped>
.skip-requirements {
	@include flex-col-center;

	&__label {
		margin-bottom: 0.5rem;
		color: #372615;
		font-size: 0.875rem;
		line-height: 1rem;
		text-align: center;
	}

	&__price {
		@include flex-row-center;
		align-items: baseline;
		gap: 0.5rem;
		margin-bottom: 0.75rem;
		color: #372615;
		font-size: 0.875rem;

		span {
			font-weight: 800;
		}

		.price {
			display: inline-flex;

			:deep(.price__value) {
				color: #372615;
				font-size: 0.875rem;
				text-shadow: none;
			}
		}
	}
}
</style>
